import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { StepsListItemSC } from './steps-list-item.styled';
//@ts-ignore
import { CircleProgress } from 'react-gradient-progress';
import {
  CIRCLE_CHART_GRADIENT_LEVELS,
  getPercentage,
} from '../../../../../helpers/behavioral-helpers';
import { FormattedMessage } from 'react-intl';

interface StepsListItemProps {
  steps: number;
  goal: number;
  date: string;
  period: string;
}

const StepsListItem: React.FC<StepsListItemProps> = ({ steps, goal, date, period }) => {
  const [percentage, setPercentage] = useState<number>(0);

  useEffect(() => {
    if (goal && steps) {
      setPercentage(getPercentage(steps, goal));
    }
  }, [goal, steps]);

  return (
    <StepsListItemSC>
      <div className="summary">
        <div className="summary__progress">
          <b className={steps ? 'count' : 'count empty'}>{percentage ? percentage : '--'}%</b>
          {percentage !== undefined ? (
            <CircleProgress
              percentage={percentage && percentage > 100 ? 100 : percentage}
              width={55}
              strokeWidth={4}
              secondaryColor="#EAEBF0"
              primaryColor={
                percentage && percentage >= 100
                  ? CIRCLE_CHART_GRADIENT_LEVELS[2]
                  : percentage === undefined
                  ? CIRCLE_CHART_GRADIENT_LEVELS[3]
                  : percentage && percentage >= 51
                  ? CIRCLE_CHART_GRADIENT_LEVELS[1]
                  : CIRCLE_CHART_GRADIENT_LEVELS[0]
              }
            />
          ) : (
            ''
          )}
        </div>
        <div className="summary__date">
          {period === 'day' ? moment(date).format('HH:mm:ss') : moment(date).format('DD.MM.YYYY')}
        </div>
      </div>
      <div className="count">
        <div className="count__steps">{steps.toLocaleString()}</div>
        <div className="count__goal">
          <FormattedMessage id="life-id.target" />: {goal.toLocaleString()}
        </div>
      </div>
    </StepsListItemSC>
  );
};

export default StepsListItem;
